import { v4 as uuidv4 } from "uuid";
import { MOCK_UUID } from "./constants/request";

export const getUUID = () => {
  return process.env.NODE_ENV === "test" ? MOCK_UUID : uuidv4();
};
